import React from 'react';

const LANGUAGE_FIELD_CONFIG = [
  { code: 'en',    field: 'shop_tag_en',    label: '英文', placeholder: 'Taiwan Food Specialty' },
  { code: 'km',    field: 'shop_tag_km',    label: '高棉语' },
  { code: 'ms',    field: 'shop_tag_ms',    label: '马来语' },
  { code: 'zh_tw', field: 'shop_tag_zh_tw', label: '繁体中文' },
];

const ShopTagCard = ({ settings, onChange, enabledLanguages = ['en', 'km'] }) => {
  const visibleFields = LANGUAGE_FIELD_CONFIG.filter(l => enabledLanguages.includes(l.code));

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <h3 className="font-semibold mb-4">店铺标语</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">中文</label>
          <input type="text" value={settings.shop_tag}
            onChange={e => onChange('shop_tag', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="台灣食品專賣店" />
        </div>
        {visibleFields.map(lang => (
          <div key={lang.code}>
            <label className="block text-sm font-medium mb-1">{lang.label}</label>
            <input type="text" value={settings[lang.field] || ''}
              onChange={e => onChange(lang.field, e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder={lang.placeholder} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopTagCard;